import React from 'react';
import ImportsPage from './imports-page';

const Imports = () => {
  return <ImportsPage />;
};

export default Imports;
